const BASE = "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-07/prod_agent_8873ce71-5b0c-4935-a990-b42d3a2b9b9c";

export interface Photo {
  id: string;
  url: string;
  caption: string;
  album: string;
}

export interface Album {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  color: string;
  photos: Photo[];
}

// ─── Album 1 : Portraits de la Fondatrice ────────────────────────────────────
const portraitsPhotos: Photo[] = [
  { id: "p1",  url: `${BASE}/IMG_0675_f303c5e91f5d4ed19d3535116c3d1ddf.jpeg`, caption: "Portrait officiel — Studio", album: "portraits" },
  { id: "p2",  url: `${BASE}/IMG_0676_6aa28e6b1ae444b7bf6cbb63b513588b.jpeg`, caption: "Portrait élégant col haut", album: "portraits" },
  { id: "p3",  url: `${BASE}/IMG_0677_5b5676ec3fcb47f5ba3ec65e827eb4fa.jpeg`, caption: "Pose artistique fond noir", album: "portraits" },
  { id: "p4",  url: `${BASE}/IMG_0678_c74d1b3f15bb4a5ca13a9be9a4d47be3.jpeg`, caption: "Assise sur chaise en bois", album: "portraits" },
  { id: "p5",  url: `${BASE}/IMG_0673_6c5928f74b74413695aa16b69d23f779.jpeg`, caption: "Portrait sur banc", album: "portraits" },
  { id: "p6",  url: `${BASE}/IMG_0674_2eabb0dc245248f09b14c3e0eb3244fb.jpeg`, caption: "Sourire confiant", album: "portraits" },
  { id: "p7",  url: `${BASE}/IMG_0635_59efa88366e845fd8ab6cf328da2c3e4.jpeg`, caption: "Costume rayé noir", album: "portraits" },
  { id: "p8",  url: `${BASE}/IMG_0665_de1f36b40e3b4bfbab9c2606f220121d.jpeg`, caption: "Tailleur bleu ciel", album: "portraits" },
  { id: "p9",  url: `${BASE}/IMG_0666_78a68c7f6797424db64b92569fe158aa.jpeg`, caption: "Portrait rapproché", album: "portraits" },
  { id: "p10", url: `${BASE}/IMG_0664_9b72d2a39cd9494a92efa0b69d3ebf54.jpeg`, caption: "Blazer bleu professionnel", album: "portraits" },
];

// ─── Album 2 : Cérémonies & Distinctions ─────────────────────────────────────
const ceremoniesPhotos: Photo[] = [
  { id: "c1", url: `${BASE}/IMG_0668_fe8cb9d849c741fca2f8e5df4f48d7ec.jpeg`, caption: "Cérémonie — Robe dorée", album: "ceremonies" },
  { id: "c2", url: `${BASE}/IMG_0669_7a7eb36185b94d0788ed53788189f6bb.jpeg`, caption: "Remise de distinction — Microphone & Trophée", album: "ceremonies" },
  { id: "c3", url: `${BASE}/IMG_0670_647e295df2d047f4bb63055353b8028c.jpeg`, caption: "Réception du prix officiel", album: "ceremonies" },
  { id: "c4", url: `${BASE}/IMG_0671_c64af65a66fb41d6b46e77ab1c2d6ac6.jpeg`, caption: "Sur scène — Grand écran FGNB", album: "ceremonies" },
  { id: "c5", url: `${BASE}/IMG_0672_b4bee971eba143e0b468dffbef19975d.jpeg`, caption: "Gala — Robe de perles", album: "ceremonies" },
];

// ─── Album 3 : Actions Humanitaires ──────────────────────────────────────────
const actionsPhotos: Photo[] = [
  { id: "a1",  url: `${BASE}/f3d63c7a-dfd7-48ea-9215-9cf5b0ba1eb4_683c15186887469a803e5ee84323aea9.jpeg`, caption: "Distribution de vivres — Sacs de riz", album: "actions" },
  { id: "a2",  url: `${BASE}/IMG_0636_3b8a8a3c168b43539436f91b7a9ca1cd.jpeg`, caption: "Stocks de denrées alimentaires", album: "actions" },
  { id: "a3",  url: `${BASE}/IMG_0644_dcbe5e7d9b674c9aa169535eed7015fd.jpeg`, caption: "Distribution de dons aux familles", album: "actions" },
  { id: "a4",  url: `${BASE}/IMG_0645_05c381a2ead4456a84930450114179b1.jpeg`, caption: "Remise de kits aux bénéficiaires", album: "actions" },
  { id: "a5",  url: `${BASE}/IMG_0643_99ffdbe59d9342c0b8cb40665577f776.jpeg`, caption: "Famille accompagnée par la fondation", album: "actions" },
  { id: "a6",  url: `${BASE}/IMG_0651_45a30435ce4740718df92d44db63b5cd.jpeg`, caption: "Partenaire — Tenue officielle FGNB", album: "actions" },
  { id: "a7",  url: `${BASE}/IMG_0663_199729abd4384dc3b6447a0210cd32f0.jpeg`, caption: "Distribution de fournitures scolaires", album: "actions" },
];

// ─── Album 4 : Événements & Enfants ──────────────────────────────────────────
const eventsPhotos: Photo[] = [
  { id: "e1",  url: `${BASE}/IMG_0649_57924384b05d47e795e0a27c8bb791c5.jpeg`, caption: "Réunion avec les enfants", album: "events" },
  { id: "e2",  url: `${BASE}/IMG_0639_942c4529c348434bbdd88ecb9864accd.jpeg`, caption: "Activité sportive — Football juniors", album: "events" },
  { id: "e3",  url: `${BASE}/IMG_0646_d4027f921f574f64bc5c66f2d10aa48d.jpeg`, caption: "Rassemblement communautaire", album: "events" },
  { id: "e4",  url: `${BASE}/IMG_0647_172144653bf8488faa2426d1f566797b.jpeg`, caption: "Interaction avec la communauté", album: "events" },
  { id: "e5",  url: `${BASE}/IMG_0650_7907150ddb66475a97717abe1f71c794.jpeg`, caption: "Événement intérieur FGNB", album: "events" },
  { id: "e6",  url: `${BASE}/IMG_0653_1f7a7230621c45bf97b83f6ca6b83934.jpeg`, caption: "Enfants participants — Session", album: "events" },
  { id: "e7",  url: `${BASE}/IMG_0654_4eee87e6ee52484d8722dfb85ddb311c.jpeg`, caption: "Prise de parole — Animation communautaire", album: "events" },
  { id: "e8",  url: `${BASE}/IMG_0656_732e419a4fd54132be30e7322de539d3.jpeg`, caption: "Jeunesse — Rencontre FGNB", album: "events" },
  { id: "e9",  url: `${BASE}/IMG_0659_5c3aa17b3dfd4ddcaebd3599d4bd407a.jpeg`, caption: "Enfants — Session participative", album: "events" },
  { id: "e10", url: `${BASE}/IMG_0662_3175133b23bd439484bbd0fffc4585cd.jpeg`, caption: "Activité extérieure en communauté", album: "events" },
  { id: "e11", url: `${BASE}/IMG_0667_fb5dcb3e745d453d8d1f41fe6e82fa9e.jpeg`, caption: "Logo officiel — Fondation Gath Naël Beko", album: "events" },
];

// ─── Album 5 : Équipe FGNB ────────────────────────────────────────────────────
const equipePhotos: Photo[] = [
  { id: "q1",  url: `${BASE}/IMG_0637_23b6e2eab9964846a69c33c13d8439ff.jpeg`, caption: "Membre de l'équipe — Polo FGNB", album: "equipe" },
  { id: "q2",  url: `${BASE}/IMG_0638_530d6a9294074dae88e76cb5908754fa.jpeg`, caption: "Bénévole en mission", album: "equipe" },
  { id: "q3",  url: `${BASE}/IMG_0640_9a3897f87110476e88be29f7ed14a593.jpeg`, caption: "Coordinatrice terrain", album: "equipe" },
  { id: "q4",  url: `${BASE}/IMG_0641_294c02d2282c417582e52e0b7ff4185c.jpeg`, caption: "Jeune bénévole — Mission terrain", album: "equipe" },
  { id: "q5",  url: `${BASE}/IMG_0642_120f9f28d86b4bbd88ad6850a1b9549f.jpeg`, caption: "Concertation — Responsables FGNB", album: "equipe" },
  { id: "q6",  url: `${BASE}/IMG_0652_25ce5f938e75474d858e5a17a0f66acd.jpeg`, caption: "Trio équipe féminine FGNB", album: "equipe" },
  { id: "q7",  url: `${BASE}/IMG_0655_f3612331c7014d87a193b6fed4ccac22.jpeg`, caption: "Équipe féminine — Journée terrain", album: "equipe" },
  { id: "q8",  url: `${BASE}/IMG_0658_5d95f3a1e3164a4ea605873e3987e204.jpeg`, caption: "Responsable en mission", album: "equipe" },
  { id: "q9",  url: `${BASE}/IMG_0660_59ce986357db459694e7ca464868213a.jpeg`, caption: "Bénévole sur le terrain", album: "equipe" },
  { id: "q10", url: `${BASE}/IMG_0661_015e63eb6fda4f419a2e81afb2329f4d.jpeg`, caption: "Équipe FGNB — Photo de groupe", album: "equipe" },
];

// ─── Albums export ─────────────────────────────────────────────────────────────
export const ALBUMS: Album[] = [
  {
    id: "portraits",
    title: "Portraits de la Fondatrice",
    subtitle: "Mme Belhuguette Beko Bokau en images",
    cover: portraitsPhotos[0].url,
    color: "from-primary/80 to-primary/40",
    photos: portraitsPhotos,
  },
  {
    id: "ceremonies",
    title: "Cérémonies & Distinctions",
    subtitle: "Reconnaissance de l'engagement humanitaire",
    cover: ceremoniesPhotos[0].url,
    color: "from-amber-900/80 to-amber-700/40",
    photos: ceremoniesPhotos,
  },
  {
    id: "actions",
    title: "Actions Humanitaires",
    subtitle: "Distribution, vivres et soutien aux familles",
    cover: actionsPhotos[0].url,
    color: "from-emerald-900/80 to-emerald-700/40",
    photos: actionsPhotos,
  },
  {
    id: "events",
    title: "Événements & Enfants",
    subtitle: "Rencontres communautaires et activités jeunesse",
    cover: eventsPhotos[0].url,
    color: "from-blue-900/80 to-blue-700/40",
    photos: eventsPhotos,
  },
  {
    id: "equipe",
    title: "Équipe FGNB",
    subtitle: "Bénévoles et coordinateurs sur le terrain",
    cover: equipePhotos[0].url,
    color: "from-violet-900/80 to-violet-700/40",
    photos: equipePhotos,
  },
];

// Best hero photo for presentation
export const HERO_PHOTO = portraitsPhotos[0].url; // IMG_0675

export const ALL_PHOTOS: Photo[] = [
  ...portraitsPhotos,
  ...ceremoniesPhotos,
  ...actionsPhotos,
  ...eventsPhotos,
  ...equipePhotos,
];
